import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const submissionSchema = z.object({
  packageId: z.enum(["coaching-20", "single-30", "single-45", "unlimited-30"]),
  packageName: z.string().min(1),
  packagePrice: z.string().min(1),
  name: z.string().min(1),
  email: z.string().email(),
  phone: z.string().optional(),
  role: z.string().optional(),
  times: z.string().optional(),
  jd: z.string().max(8000, "Job description must be 8,000 characters or less").optional(),
});

export const submitInterviewRequest = createServerFn({ method: "POST" })
  .validator((input) => submissionSchema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { data: inserted, error } = await supabaseAdmin
      .from("interview_requests")
      .insert({
        package_id: data.packageId,
        package_name: data.packageName,
        package_price: data.packagePrice,
        name: data.name,
        email: data.email,
        phone: data.phone ?? null,
        role: data.role ?? null,
        preferred_times: data.times ?? null,
        job_description: data.jd ?? null,
      })
      .select("id")
      .single();

    if (error) {
      console.error("Failed to save interview request:", error);
      throw new Error("Failed to save your request. Please try again.");
    }

    try {
      const { sendTemplateEmail } = await import("@/lib/email-templates/send-email");
      await sendTemplateEmail("interview-request-notification", "", {
        templateData: {
          name: data.name,
          email: data.email,
          phone: data.phone ?? "",
          role: data.role ?? "",
          times: data.times ?? "",
          jd: data.jd ?? "",
          packageName: data.packageName,
          packagePrice: data.packagePrice,
        },
        replyTo: data.email,
        idempotencyKey: `interview-request-notification-${inserted?.id ?? data.email}`,
      });
    } catch (emailError) {
      console.error("Failed to send notification email:", emailError);
    }

    return { success: true };
  });

